import { ApolloProvider } from '@apollo/client';
import { Shell } from '@do/seashell';
import { createApolloClient } from '@do/seashell/utils';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import styled from 'styled-components/macro';
import AppIndex from './components/AppIndex';

const AppContainer = styled.div`
  display: none;
`;

const FEATURES = ['pdocs_style'];

// If error detail matches a string in errStringsFor404, then redirect to 404
const errStringsFor404: string[] = [];
const clientName = 'ui-post-message-app';
const client = createApolloClient({ errStringsFor404, name: clientName });

const App: React.FC = () => {
  return (
    <AppContainer>
      <ApolloProvider client={client}>
        <Shell
          features={FEATURES}
          routerProps={{ basename: 'post-message-app' }}
          dontRedirectOnLoginError
        >
          <Routes>
            <Route path="*" element={<AppIndex />} />
          </Routes>
        </Shell>
      </ApolloProvider>
    </AppContainer>
  );
};

export default App;
